import { PageSizeSelectorStateProps } from 'components/atoms/tables/PageSizeSelector'
import CommonHeaderMobile from 'components/molecules/tables/CommonHeaderMobile'
import { PaginatorStateProps } from 'components/molecules/tables/Paginator'
import { Table2StateProps } from 'components/molecules/tables/Table'
import Table2 from 'components/molecules/tables/Table2'
import { EmptyCardBlock } from 'components/features/pfm/Blocks/Blocks'
import Pagination from 'components/features/pfm/Pagination/Pagination'
import * as styles from 'components/features/pfm/RedemptionsModule/RedemptionsModule.css'
import RedemptionsModuleHeader from 'components/features/pfm/RedemptionsModule/RedemptionsModuleHeader'
import RedemptionsModuleRow from 'components/features/pfm/RedemptionsModule/RedemptionsModuleRow'
import RedemptionsModuleRowMobile from 'components/features/pfm/RedemptionsModule/RedemptionsModuleRowMobile'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { WithMobileProps } from 'hocs/withMobile/withMobile'
import { Collection, Omit } from 'interfaces'
import { Redemption } from 'interfaces/bounty'
import { Transaction } from 'interfaces/moneyflow'
import { BaseSorting } from 'interfaces/table'
import { PureComponent } from 'react'

export type RedemptionsModuleStateProps =
  & Omit<Table2StateProps<Transaction>, 'rows'>
  & {
    pageSize: PageSizeSelectorStateProps
    paginator: PaginatorStateProps
    sorting: BaseSorting
    rowsCollection: Collection<Redemption, 'id'>
  }

export type RedemptionsModuleDispatchProps = {
  onPageClick: (page: number) => void
  onPageSizeClick: (pageSize: number) => void
  onSortingClick: (sorting: BaseSorting) => void
}

type RedemptionsModuleProps =
  & WithMobileProps
  & RedemptionsModuleStateProps
  & RedemptionsModuleDispatchProps

const getRowKey = ({ id }: Redemption) => String(id)

class RedemptionsModule extends PureComponent<RedemptionsModuleProps, {}> {
  render () {
    const {
      isLoading,
      rowsCollection,
      sorting,
      isMobile,
      onSortingClick,
    } = this.props

    const rows = getItemsFromCollection(rowsCollection)

    if (!rows.length) {
      return (
        <EmptyCardBlock corners='all' forceRoundedCorners shadowTheme='regular'>
          You have no redemptions.
        </EmptyCardBlock>
      )
    }

    const HeaderComponent = isMobile
      ? () => <CommonHeaderMobile type='redemptions' />
      : RedemptionsModuleHeader

    const RowComponent = isMobile ? RedemptionsModuleRowMobile : RedemptionsModuleRow

    return (
      <div className={ styles.redemptionsModule }>
        <Table2
          getRowKey={ getRowKey }
          rows={ rows }
          sorting={ sorting }
          isLoading={ isLoading }
          onChangeSorting={ onSortingClick }
        >
          <Table2.HeadRowMarker>
            <HeaderComponent />
          </Table2.HeadRowMarker>
          <Table2.Rows>
            <Table2.RowTemplate>
              {
                (row: Redemption) => (
                  <RowComponent key={ row.id } row={ row } />
                )
              }
            </Table2.RowTemplate>
          </Table2.Rows>
        </Table2>
        <Pagination { ...this.props } />
      </div>
    )
  }
}

export default RedemptionsModule
